import { Notification } from "../../../components/notification/notification";
import { UserState } from "../../../types/types";
import {
  DOWNLOAD_USER_TEMPLATE_FAILURE,
  DOWNLOAD_USER_TEMPLATE_REQUEST,
  DOWNLOAD_USER_TEMPLATE_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USER_DATA_BY_ID_FAILURE,
  GET_USER_DATA_BY_ID_REQUEST,
  GET_USER_DATA_BY_ID_SUCCESS,
  GET_EDIT_FORM_FAILURE,
  GET_EDIT_FORM_REQUEST,
  GET_EDIT_FORM_SUCCESS,
  SAVE_USER_DATA_BY_ID_FAILURE,
  SAVE_USER_DATA_BY_ID_REQUEST,
  SAVE_USER_DATA_BY_ID_SUCCESS,
  UPLOAD_USER_FAILURE,
  UPLOAD_USER_REQUEST,
  UPLOAD_USER_SUCCESS,
  USER_FILE_UPLOAD_REQUEST,
  USER_FILE_UPLOAD_SUCCESS,
  USER_FILE_UPLOAD_FAILURE,
  GET_VIEW_FORM_FAILURE,
  GET_VIEW_FORM_REQUEST,
  GET_VIEW_FORM_SUCCESS,
  GET_DATA_TABLE_SUCCESS,
  GET_DATA_TABLE_REQUEST,
  GET_DATA_TABLE_FAILURE,
  GET_SEARCH_FILTERS_FAILURE,
  GET_SEARCH_FILTERS_REQUEST,
  GET_SEARCH_FILTERS_SUCCESS,
  DELETE_RECORD_REQUEST,
  DELETE_RECORD_SUCCESS,
  DELETE_RECORD_FAILURE,
  CREATE_NEW_RECORD_REQUEST,
  CREATE_NEW_RECORD_SUCCESS,
  CREATE_NEW_RECORD_FAILURE,
  DOWNLOAD_USER_REPORT_REQUEST,
  DOWNLOAD_USER_REPORT_SUCCESS,
  DOWNLOAD_USER_REPORT_FAILURE,
  UPLOAD_USERROFILE_FAILURE,
  UPLOAD_USERROFILE_REQUEST,
  UPLOAD_USERROFILE_SUCCESS,
  UPLOAD_USERROFILE_LOADER,
  EXTERNAL_USER_INFO
} from "./actionTypes";

const userState: UserState = {
  usersData: {
    loading: false,
    data: null,
  },
  userDataTable: {
    data: null,
    loading: false,
  },
  userTemplate: {
    loading: false,
    data: null,
  },
  userReport: {
    loading: false,
    data: null,
  },
  userUpload: {
    loading: false,
    data: null,
  },
  userSearchFilters: {
    data: null,
    loading: false,
  },
  userEditForm: {
    data: null,
    loading: false,
  },
  userViewForm: {
    data: null,
    loading: false,
  },
  userViewData: {
    data: null,
    loading: false,
  },
  userDataSave: {
    data: null,
    loading: false,
  },
  createNewRecord: {
    data: null,
    loading: false,
  },
  deleteRecordData: {
    data: null,
    loading: false,
  },
  userProfileUpload: {
    data: null,
    loading: false,
  },
  externalUserInfo: {
    data: null,
  }
};

export default (state = userState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return {
        ...state,
        usersData: {
          loading: true,
          data: null,
        },
      };

    case GET_USERS_SUCCESS:
      return {
        ...state,
        usersData: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_USERS_FAILURE:
      return {
        ...state,
        usersData: {
          loading: false,
          data: action.payload,
        },
      };

    case DOWNLOAD_USER_TEMPLATE_REQUEST:
      return {
        ...state,
        userTemplate: {
          loading: true,
          data: null,
        },
      };

    case DOWNLOAD_USER_TEMPLATE_SUCCESS:
      return {
        ...state,
        userTemplate: {
          loading: false,
          data: action.payload,
        },
      };

    case DOWNLOAD_USER_TEMPLATE_FAILURE:
      return {
        ...state,
        userTemplate: {
          loading: false,
          data: action.payload,
        },
      };

    case DOWNLOAD_USER_REPORT_REQUEST:
      return {
        ...state,
        userReport: {
          loading: true,
          data: action.payload,
        },
      };

    case DOWNLOAD_USER_REPORT_SUCCESS:
      return {
        ...state,
        userReport: {
          loading: false,
          data: action.payload,
        },
      };

    case DOWNLOAD_USER_REPORT_FAILURE:
      return {
        ...state,
        userReport: {
          loading: false,
          data: action.payload,
        },
      };

    case UPLOAD_USERROFILE_LOADER:
      console.log('in')
      return {
        ...state,
        userProfileUpload: {
          loading: true,
          data: null,
        },
      };
    case UPLOAD_USERROFILE_REQUEST:
      return {
        ...state,
        userProfileUpload: {
          loading: true,
          data: null,
        },
      };

    case UPLOAD_USERROFILE_SUCCESS:
      return {
        ...state,
        userProfileUpload: {
          loading: false,
          data: action.payload,
        },
      };

    case UPLOAD_USERROFILE_FAILURE:
      return {
        ...state,
        userProfileUpload: {
          loading: false,
          data: action.payload,
        },
      };

    case UPLOAD_USER_REQUEST:
      return {
        ...state,
        userUpload: {
          loading: true,
          data: null,
        },
      };

    case UPLOAD_USER_SUCCESS:
      return {
        ...state,
        userUpload: {
          loading: false,
          data: action.payload,
        },
      };

    case UPLOAD_USER_FAILURE:
      return {
        ...state,
        userUpload: {
          loading: false,
          data: action.payload,
        },
      };
    case USER_FILE_UPLOAD_REQUEST:
      return {
        ...state,
        userUpload: {
          loading: true,
          data: null
        },
      };

    case USER_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        userUpload: {
          loading: false,
          data: action.payload,
        },
      };

    case USER_FILE_UPLOAD_FAILURE:
      return {
        ...state,
        userUpload: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DATA_TABLE_REQUEST:
      return {
        ...state,
        userDataTable: {
          loading: true,
          data: null,
        },
      };

    case GET_DATA_TABLE_SUCCESS:
      return {
        ...state,
        userDataTable: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DATA_TABLE_FAILURE:
      return {
        ...state,
        userDataTable: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_SEARCH_FILTERS_REQUEST:
      return {
        ...state,
        userSearchFilters: {
          loading: true,
          data: null,
        },
      };

    case GET_SEARCH_FILTERS_SUCCESS:
      return {
        ...state,
        userSearchFilters: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_SEARCH_FILTERS_FAILURE:
      return {
        ...state,
        userSearchFilters: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_EDIT_FORM_REQUEST:
      return {
        ...state,
        userEditForm: {
          loading: true,
          data: null,
        },
      };

    case GET_EDIT_FORM_SUCCESS:
      return {
        ...state,
        userEditForm: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_EDIT_FORM_FAILURE:
      return {
        ...state,
        userEditForm: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_VIEW_FORM_REQUEST:
      return {
        ...state,
        userViewForm: {
          loading: true,
          data: null,
        },
      };

    case GET_VIEW_FORM_SUCCESS:
      return {
        ...state,
        userViewForm: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_VIEW_FORM_FAILURE:
      return {
        ...state,
        userViewForm: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_USER_DATA_BY_ID_REQUEST:
      return {
        ...state,
        userViewData: {
          loading: true,
          data: null,
        },
      };

    case GET_USER_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        userViewData: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_USER_DATA_BY_ID_FAILURE:
      return {
        ...state,
        userViewData: {
          loading: false,
          data: action.payload,
        },
      };

    case SAVE_USER_DATA_BY_ID_REQUEST:
      return {
        ...state,
        userDataSave: {
          loading: true,
          data: null,
        },
      };

    case SAVE_USER_DATA_BY_ID_SUCCESS:
      Notification(
        "success",
        "Updated Successfully"
      )
      return {
        ...state,
        userDataSave: {
          loading: false,
          data: action.payload,
        },
      };

    case SAVE_USER_DATA_BY_ID_FAILURE:
      Notification(
        "error",
        "Transaction Failed"
      )
      return {
        ...state,
        userDataSave: {
          loading: false,
          data: action.payload,
        },
      };

    case CREATE_NEW_RECORD_REQUEST:
      return {
        ...state,
        createNewRecord: {
          loading: true,
          data: null,
        },
      };

    case CREATE_NEW_RECORD_SUCCESS:
      Notification(
        "success",
        "Created Successfully"
      )
      return {
        ...state,
        createNewRecord: {
          loading: false,
          data: action.payload,
        },
      };

    case CREATE_NEW_RECORD_FAILURE:
      Notification(
        "error",
        "Transaction Failed"
      )
      return {
        ...state,
        createNewRecord: {
          loading: false,
          data: action.payload,
        },
      };


    case DELETE_RECORD_REQUEST:
      return {
        ...state,
        deleteRecordData: {
          loading: true,
          data: null,
        },
      };

    case DELETE_RECORD_SUCCESS:
      console.log(action);

      Notification(
        "success",
        "Delete Successfully"
      )
      return {
        ...state,
        deleteRecordData: {
          loading: false,
          data: action.payload,
        },
      };

    case DELETE_RECORD_FAILURE:
      return {
        ...state,
        deleteRecordData: {
          loading: false,
          data: action.payload,
        },
      };

    case EXTERNAL_USER_INFO:
      return {
        ...state,
        externalUserInfo: {
          data: action.payload,
        },
      };

    default:
      return {
        ...state,
      };
  }
};
